import {
  aCreateSumoMapping,
  mockCreateSumoMappingOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateSumoMappingOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createSumoMapping: aCreateSumoMapping(),
        },
      });
    }
  ),
];
